import { useState, useEffect } from "react";
import screenfull from "screenfull";

/**
 * フルスクリーン中のフルスクリーン要素。フルスクリーンでなければ undefined。
 */
export const getFullscreenContainer = () => {
  if (!screenfull.isEnabled || !screenfull.isFullscreen) {
    return undefined;
  }
  return screenfull.element;
};

/**
 * screenfull.isFullscreenの変化を検知するカスタムフック
 */
export const useFullscreen = () => {
  const [isFullscreen, setIsFullscreen] = useState(
    screenfull.isEnabled ? screenfull.isFullscreen : false
  );

  useEffect(() => {
    if (!screenfull.isEnabled) {
      return;
    }

    const handleFullscreenChange = () => {
      setIsFullscreen(screenfull.isFullscreen);
    };

    screenfull.on("change", handleFullscreenChange);

    return () => {
      screenfull.off("change", handleFullscreenChange);
    };
  }, []);

  const handleExitFullscreen = async () => {
    if (screenfull.isEnabled) {
      await screenfull.exit();
    }
  };

  return {
    isFullscreen,
    handleExitFullscreen,
  };
};
